import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Customer } from '../types';

interface AuthState {
  user: User | null;
  customer: Customer | null;
  setUser: (user: User | null) => void;
  setCustomer: (customer: Customer | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      customer: null,
      setUser: (user) => set({ user }),
      setCustomer: (customer) => set({ customer }),
      logout: () => set({ user: null, customer: null }),
    }),
    {
      name: 'varinym-auth',
    }
  )
);
